import { cn } from '@/lib/utils';
import type { ProfileFormData } from './types';

interface Props {
  ownerName: string;
  data: ProfileFormData;
  onChange: (patch: Partial<ProfileFormData>) => void;
}

export function VeteranStep({ ownerName, data, onChange }: Props) {
  return (
    <div className="space-y-8">
      <h2 className="font-bold text-3xl">{ownerName}.veteran?</h2>

      <div className="space-y-6 text-secondary-foreground">
        <p>has participado de otras hackatones?</p>
      </div>

      <div className="mb-8 space-y-4">
        <div className="mb-3 block font-semibold text-sm">veteran? *</div>

        <label
          className={cn(
            'flex cursor-pointer items-start gap-4 rounded-lg border-2 p-4 transition-colors',
            data.isVeteran === true
              ? 'border-primary bg-primary/10'
              : 'border-border bg-transparent',
          )}
        >
          <input
            type="radio"
            name="veteran"
            checked={data.isVeteran === true}
            onChange={() => onChange({ isVeteran: true })}
            className="sr-only"
          />
          <div className="font-semibold">true</div>
        </label>

        <label
          className={cn(
            'flex cursor-pointer items-start gap-4 rounded-lg border-2 p-4 transition-colors',
            data.isVeteran === false
              ? 'border-primary bg-primary/10'
              : 'border-border bg-transparent',
          )}
        >
          <input
            type="radio"
            name="veteran"
            checked={data.isVeteran === false}
            onChange={() => onChange({ isVeteran: false })}
            className="sr-only"
          />
          <div className="font-semibold">false</div>
        </label>
      </div>

      {data.isVeteran === true && (
        <div className="space-y-4">
          <div className="block font-semibold text-sm">cuáles? *</div>
          <textarea
            placeholder="platanus hack 24, treehacks 24, fecebook hack chile 21, etc"
            value={data.previousHackathons}
            onChange={(e) => onChange({ previousHackathons: e.target.value })}
            className="min-h-[150px] w-full rounded border border-border bg-card px-4 py-3 text-foreground placeholder-secondary-foreground focus:border-primary focus:outline-none"
          />
        </div>
      )}
    </div>
  );
}
